import axios from 'axios';

//@ts-ignore
const toastr: any = window.toastr;
//@ts-ignore
const Webcam: any = window.Webcam;

function getPhoto(mock_user_photo_b64) {
	Webcam.set({
		width: 420,
		height: 310,
		image_format: 'jpeg',
		jpeg_quality: 100,
	});
	const is_mock_enabled = mock_user_photo_b64 !== '';

	var p2: Promise<string> = new Promise((resolve, reject) => {
		if (is_mock_enabled) {
			return resolve(mock_user_photo_b64);
		}
		toastr.success(`Estamos batendo uma foto`, '', { timeOut: 5000 });
		Webcam.snap((data_uri: string) => {
			let block: Array<string> = data_uri.split(';');
			let contentType: string = block[0].split(':')[1];
			let realData: string = block[1].split(',')[1];
			Webcam.reset();
			resolve(realData);
		});
	});

	var promise: Promise<string> = new Promise((resolve, reject) => {
		if (is_mock_enabled) {
			return resolve(mock_user_photo_b64);
		}
		var callback = function () {
			resolve(p2);
		};
		if (Webcam.loaded === false) {
			Webcam.reset();
			Webcam.attach('#camera');
			Webcam.off('load');
			Webcam.on('load', callback);
		} else {
			resolve(p2);
		}
	});
	return promise;
}

function SnapPhotoAndSendRequestSavePhoto(
	url_to_send: string,
	mock_student_photo_url: string | null = null
) {
	getPhoto(mock_student_photo_url).then((b64) => {
		axios
			.post(url_to_send, {
				data: {
					base64_file: b64,
				},
				timeout: 600000,
			})
			.then(() => {
				toastr.success(`Foto tirada com sucesso`, '', {
					timeOut: 5000,
				});
			})
			.catch((error) => {
				alert('error' + error);
			});
	});
}

export { getPhoto, SnapPhotoAndSendRequestSavePhoto };
